export enum Frais {
	Beneficiaire = 'beneficiaire',
	Emetteur = 'emetteur',
	Partage = 'partage'
}

export enum Virements {
	SaisieVirementManuscrit = 'saisieVirementManuscrit',
	VirementUrgent = 'virementUrgent',
	VirementTarget = 'virementTarget'
}
